import { FiArrowUpRight, FiDownload, FiFileText } from "react-icons/fi";
import Container from "../container";
import c from "./styles.module.scss";

const fileUrl = "/presentation.pdf"
const Presentation = () => {
    return (
        <section className={c.section} aria-labelledby="presentation-title">
            <Container>
                <div className={c.card}>
                    <div className={c.intro}>
                        <span className={c.label}>G-FACTORY / ПРЕЗЕНТАЦИЯ</span>
                        <h1 id="presentation-title" className={c.title}>Знакомьтесь с G-Factory</h1>
                        <p className={c.description}>
                            {fileUrl
                                ? "Наша презентация — в одном файле. Посмотрите её онлайн или сохраните, чтобы вернуться к ней в удобное время."
                                : "Скоро здесь появится наша презентация. Вы сможете посмотреть её онлайн или сохранить себе."}
                        </p>
                        {fileUrl ? (
                            <div className={c.actions}>
                                <a className={c.primary} href={fileUrl} target="_blank" rel="noopener noreferrer">
                                    Открыть презентацию <FiArrowUpRight aria-hidden="true" />
                                </a>
                                <a className={c.secondary} href={fileUrl} download>
                                    Скачать PDF <FiDownload aria-hidden="true" />
                                </a>
                            </div>
                        ) : <span className={c.status}>Готовим презентацию</span>}
                    </div>
                    <div className={c.document} aria-hidden="true">
                        <div className={c.sheet}>
                            <span className={c.brand}>G-FACTORY</span>
                            <FiFileText className={c.fileIcon} />
                            <span className={c.documentTitle}>Презентация</span>
                            <span className={c.format}>PDF</span>
                        </div>
                    </div>
                </div>
                {fileUrl && (
                    <div className={c.preview}>
                        <div className={c.previewHeader}>
                            <h2>Просмотр презентации</h2>
                            <span>PDF</span>
                        </div>
                        <object className={c.viewer} data={fileUrl} type="application/pdf" aria-label="Презентация G-Factory">
                            <p className={c.fallback}>Для просмотра презентации <a href={fileUrl} target="_blank" rel="noopener noreferrer">откройте PDF в новой вкладке</a>.</p>
                        </object>
                        <p className={c.mobileHint}>На телефоне удобнее открыть презентацию отдельным файлом — кнопкой выше.</p>
                    </div>
                )}
              
            </Container>
        </section>
    );
};

export default Presentation;
